<template>
  <div id="app">
    <router-view />
  </div>
</template>



<script>
import settings from "@/backend/LocalSettings";

export default {
  name: "App",
  data() {
    return {
      timerNotificari: null,
    };
  },
  methods: {
    async check_version() {
      var local_version = settings.version;
      var server_version = await this.post("version/versiune_service");
      if (local_version != server_version) {
        this.$notify({
          title: "Atentie",
          message:
            'A aparut o noua versiune - <button onclick="window.location.reload(true)">Upgrade</button> ',
          dangerouslyUseHTMLString: true,
          type: "warning",
          duration: 0,
        });
      }
    },
    async verificaNotificari() {
      const token = window.localStorage.getItem("service-evio-token");
      if (!token) return;

      try {
        const response = await this.$http.post("admin/produse/notificari_noi", {});

        if (response.body.NotLogged) return;

        const notificari = response.body.notificari;

        if (notificari && notificari.length > 0) {
          await this.proceseazaNotificariSecvential(notificari, 0);
        }
      } catch (err) {
        console.error("Eroare verificare notificari:", err);
      }
    },
    async proceseazaNotificariSecvential(lista, index) {
      if (index >= lista.length) return;

      const element = lista[index];

      let textModificari = "";
      try {
        const modif_produs = JSON.parse(element.Modificare || "{}");
        const keys = Object.keys(modif_produs);
        if (keys.length > 0) {
          textModificari = keys.join(", ") + ".";
        }
      } catch (e) {
        console.error("Eroare parsare JSON", e);
      }

      const h = this.$createElement;

      try {
        await this.$msgbox({
          title: `Produsul ${element.Id} a fost modificat`,
          message: h("p", null, [
            h("span", null, `Utilizatorul ${element.NumeUtilizator} a modificat produsul `),
            h("b", { style: "color: red" }, `${element.Nume}`),
            h("br"),
            h("span", null, `Campurile modificate sunt: ${textModificari}`),
            h("br"),
            h("strong", null, `Confirmati vizualizarea?`),
          ]),
          showCancelButton: true,
          confirmButtonText: "Da",
          cancelButtonText: "Nu", 
          closeOnClickModal: false
        });

        await this.confirmaNotificare(element);

        await this.proceseazaNotificariSecvential(lista, index + 1);

      } catch (action) {
        if (action === "cancel") {
          await this.proceseazaNotificariSecvential(lista, index + 1);
        }
      }
    },

    async confirmaNotificare(element) {
      return this.$http.post("admin/produse/confirma_notificare", {
        id: element.Id,
      });
    },

    post: async function (url, args = {}) {
      var response = await this.$http.post(url, args);
      return response.bodyText;
    },

  },
  mounted() {
    this.check_version();

    this.verificaNotificari();
    this.timerNotificari = setInterval(() => {
      this.verificaNotificari();
    }, 60000);

  },
  beforeDestroy() {
    if (this.timerNotificari) clearInterval(this.timerNotificari);
  },
};
</script>

<style lang='less'>
@albastru-deschis: hsl(0, 57%, 53%);

.el-radio-button__inner {
  width:100px !important;
}
.el-tag + .el-tag[data-v-9fcbcf9a] {
  margin-left: 0px !important;
}

.navbar-dark .navbar-toggler-icon {
  color: hsl(193, 11%, 34%) !important;
  fill: hsl(193, 11%, 34%) !important;
}

.el-table tr th .cell {
  // width: auto;
  word-break: normal;
  // font-size: 12px !important;
}


.picker-limitare {



  // display: block;
  position: absolute !important;
  margin: auto !important;
  // border: 1px solid red !important;
  top: 10vw !important;
  left: 40% !important;
  // transform: translate(-50%, -50%);
  .popper__arrow::after {
    display: none !important;
  }
  .el-date-table td.selected span {
  background-color: #ff4070 ;
  }

  .el-date-table {
    pointer-events: none;
  }


}

.el-table {
  border-radius: 5px;
}

.number {
  border-radius: 5px;
  color: hsl(193, 11%, 34%) !important;
}

.text-albastru {
  color: @albastru-deschis;
}

.bg-albastru {
  background-color: @albastru-deschis;
}

.display-titlu {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
div.titlu {
  // background-color: hsl(196, 85%, 35%);
  h1 {
    color: hsl(193, 11%, 34%) !important;
    // padding: 8px 15px;
    font-family: "Lato", sans-serif;
    font-weight: 300;
    font-size: 25px;
  }
  .btn-adauga {
    // display: block;
    z-index: 1;
    text-align: center;
    height: 50px;
    // padding-left: 50px;
    // padding-right: 50px;
    // background: #409eff;
    color: hsl(193, 11%, 34%);
    background: transparent; /* Old browsers */
    border-radius: 10px !important;
    // background: -moz-linear-gradient(top, hsl(193, 11%, 34%) 0%, hsl(196, 11%, 57%) 50%, hsl(200, 11%, 58%) 100%); /* FF3.6-15 */
    // background: -webkit-linear-gradient(top, hsl(193, 11%, 34%) 0%,hsl(196, 11%, 57%) 50%,hsl(200, 11%, 58%) 100%); /* Chrome10-25,Safari5.1-6 */
    // background: linear-gradient(to top, hsl(193, 11%, 34%) 0%,hsl(196, 11%, 57%) 50%,hsl(200, 11%, 58%) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#34c2e4', endColorstr='#4fabda',GradientType=0 ); /* IE6-9 */
    border: none;
    border-radius: 0%;
    margin: 2px;
  }

  .btn-adauga:hover {
    // color: white;
    color: hsl(190, 10%, 23%);

    // background-color: hsl(0, 0%, 71%);
    background-color: transparent;
  }
}

html {
  height: 100%;
  background-position: center;
  background-size: cover;
  background-position: fixed;
  background-color: #f7f7f8;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body {
  background-color: transparent !important;
}
.my-dialog-class .el-dialog {
  width: 80%;
}
.full-width {
  width: 100%;
}



@media only screen and (max-width: 768px) {
  .el-table-column {
    padding: 0 10px !important;
  }
}

.el-date-editor--daterange.el-input, .el-date-editor.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
  width: 100% !important;
}

.butonReg {
  font-size: 9px !important;
}

.tabelRandMic {

  .el-table__row td{
    padding: 1px !important;
    height: 30px !important;
  }
}

.el-message {
  z-index: 99999999 !important;
}
</style>
